export const TOKEN = 'TOKEN'
export const CURRENT_USER = 'CURRENT_USER'



// WEBPACK FOOTER //
// ./src/store/store-keys.js